
import actions from './action'
import getters from './getters'
import state from './state'
import mutations from './mutation'

const store = {
	namespaced: true,
	actions,
	getters,
  mutations,
	state
}
export default store



// WEBPACK FOOTER //
// ./src/store/modules/batchDownload/index.js